"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErc20ValidationSchemaCreator = exports.editErc20ContractValidationSchemaCreator = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const types_1 = require("@framework/types");
const types_2 = require("../../../../../types");
const editErc20ContractValidationSchemaCreator = (service) => (0, yup_1.object)().shape({
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    imageUrl: yup_rules_1.urlValidationSchema,
    ...(service === types_2.ServiceType.ADMIN && {
        contractStatus: (0, yup_1.mixed)()
            .oneOf(Object.values(types_1.ContractStatus))
            .required("form.validations.valueMissing"),
    }),
    ...(service === types_2.ServiceType.OFFICE && {
        merchantId: yup_rules_1.dbIdValidationSchema,
    }),
});
exports.editErc20ContractValidationSchemaCreator = editErc20ContractValidationSchemaCreator;
const createErc20ValidationSchemaCreator = (service) => (0, yup_1.object)().shape({
    symbol: yup_rules_1.symbolValidationSchema,
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    address: yup_rules_eth_1.addressValidationSchema,
    decimals: (0, yup_1.number)()
        .typeError("form.validations.badInput")
        .required("form.validations.valueMissing")
        .max(32, "form.validations.rangeOverflow"),
    ...(service === types_2.ServiceType.OFFICE && {
        merchantId: yup_rules_1.dbIdValidationSchema,
    }),
});
exports.createErc20ValidationSchemaCreator = createErc20ValidationSchemaCreator;
//# sourceMappingURL=validation.js.map